import React from 'react';

import autoBind from 'react-autobind';
import Config from "../Config.jsx";

// import other components within the same project here
import LoginCreateSession from "../tools/LoginCreateSession.jsx";
import LoginDialog from "../views/LoginDialog.jsx";
import ForgetPasswordDialog from "../views/ForgetPasswordDialog.jsx";
import AgreementDialog from "../views/AgreementDialog.jsx"

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();


    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      forgetPasswordDialogOpen: false,
      agreementDialogOpen: false,
      loginResult: null,
      rememberMe: false,
      latestAgreementVersion: 0,
      agreemenText: "",
    };
    autoBind(this);

    this.fetchAgreement();
    // debug

  }

  fetchAgreement() {
    fetch(Config.AGREEMENT_URL())
      .then((resp)=>{ return resp.text() })
      .then((text)=>{
        let parser = new DOMParser();
        let doc = parser.parseFromString(text, 'text/html');
        let el = doc.querySelector('#content');
        if (!el) {
          console.warn('agreement #content missing');
          return;
        }
        let content = el.innerHTML;
        this.setState({ agreemenText: content });
        this.state.agreemenText = content;
      })
      .catch(function (err) {
        console.log("failed to load agreement");
      });
  }

  // callback from loginCreateSession
  loginOK(res, rememberMe = false){
    console.log("loginOK");
    // res is the raw superagent response; the login payload (login_result,
    // latest_agreement_version, has_read_tac) lives at res.body. Reading the fields off res
    // directly returned undefined, so the T&C agreement gate never fired.
    const body = (res && res.body) ? res.body : {};
    this.setState({loginResult: res, rememberMe: rememberMe});
    this.state.loginResult = res;
    this.state.rememberMe = rememberMe;

    if (body['latest_agreement_version'] != null) {
      let agreement_version = parseInt(body['latest_agreement_version']);
      this.setState({ latestAgreementVersion: agreement_version });
      this.state.latestAgreementVersion = agreement_version;
    }

    if (parseInt(body['has_read_tac']) < this.state.latestAgreementVersion) {
      this.showAgreement();
    }
    else {
      this.agreementAccepted();
    }
  }

  loginFailed(result){
     console.log("loginFailed");
     this.props.root.addNotification("Username / Password Incorrect", false);
  }

  sendPasswordResetRequest(email, token, onSuccess, onFail) {
    const requestObj = {
      email: email,
      recaptcha_token: token
    };
    this.props.root.refs.API.request(
      "user_reset_password",
      requestObj,
      (res) => {
        if (res.body === "recaptcha_failed") {
          onFail();
        } else {
          onSuccess();
        }
      },
      (err) => {
        console.error("Password reset request failed:", err);
        onFail();
      }
    );
  }

  forgetPasswordClicked() {
    this.setState({forgetPasswordDialogOpen: true});
    this.state.forgetPasswordDialogOpen = true;
  }

  agreementAccepted() {
    this.props.root.loginOK(this.state.loginResult, this.state.rememberMe);
  }

  showAgreement() {
    this.setState({agreementDialogOpen: true});
    this.state.agreementDialogOpen = true;
  }

  render() {
    return (
      <div style={{position:"fixed", background: "linear-gradient(#e3dae6, #bdb4bf)", width:"100%", height:"100%", top:0, left:0, bottom:0, right:0}}>
        <LoginDialog
          root={this.props.root}
          parent={this}
          ref="loginDialog"
          ssoError={this.props.ssoError}
          onDismissSsoError={this.props.onDismissSsoError}
        />
        <ForgetPasswordDialog parent={this} root={this.props.root} ref="forgetPasswordDialog"/>
        <LoginCreateSession parent={this} root={this.props.root} ref="loginCreateSession"/>
        
        <AgreementDialog root={this.props.root} parent={this} ref="agreementDialog"/>
      </div>
    )
  }
}

export default LoginPage;
